module.exports = __webpack_public_path__ + "static/media/stocks-12.3e4a0adb.jpg";